import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "./lenis";

// Navigate to a home-page section or a route from anywhere
export const useGo = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (item) => {
    const { id, route } = typeof item === "string" ? { id: item } : item;
    if (route) return navigate(route);
    if (pathname === "/") scrollToId(id);
    else navigate(`/#${id}`);
  };
};
